import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import store from "./store";
import BootstrapVue from 'bootstrap-vue';
import VueCookies from 'vue-cookies';

import '../public/css/sass/reset.scss';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '../public/css/sass/global.scss';

import Home from "./views/Home.vue";
import Profile from "./views/Profile.vue";
import Logoff from "./views/Logoff.vue";
import Loading from "./views/Loading.vue";
import './registerServiceWorker'

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VueCookies);

VueCookies.config("30d");

Vue.config.productionTip = true;

const router = new VueRouter({
    routes: [
        
        {
            path: "/Profile",
            component: Profile
        },
        {
            path: "/Logoff",
            component: Logoff
        },
        {
            path: "/Loading",
            component: Loading
        },
        {
            path: "*",
            component: Home
        }
    ],
    mode: 'history'
});

router.beforeEach((to, from, next) => {
    if (to.path.toLowerCase() == "/logoff" || to.path.toLowerCase() == "/loading") {
        next();
    } else {
        Promise.all([store.dispatch("checkAuth")]).then(() => {
            if (store.state.userInfo.isAuthenticated == true) {
                next();
            } else {
                //we need this in order to prevent a blank page from showing while the redirect loads
                next(`/Loading?returnUrl=${to.path}`);
            }
        });
    }


});

Vue.filter('toCurrency', function (value) {
    if (isNaN(value)) {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0
    });
    return formatter.format(value);
});

Vue.mixin({
    methods: {
        notNullOrEmpty(obj) {
            return (obj && Object.keys(obj).length && obj.length > 0);
        },
        collapsePanel: function (event) {
            var target = event.currentTarget.getAttribute("data-target").substring(1);
            var el = document.getElementsByClassName(target)[0];
            if (el.classList.contains("show")) {
                el.classList.remove("show");
            } else {
                el.classList.add("show");
            } 
        }
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
